module.exports = __webpack_public_path__ + "img/vesper3.12724850.jpg";